export const links = {
  job: "https://www.linkedin.com/company/trastar-inc/jobs/",
};
